// Copyright © 2021 Move Closer
import { defineComponent } from '@vue/composition-api';
import { bootstrapBadgeProps, useBootstrapBadge } from './Badge.hooks';
/**
 * @author Sebastian Dziechciarz <sebastian.dziechciarz@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const BootstrapBadge = defineComponent({
    name: 'BootstrapBadge',
    props: bootstrapBadgeProps,
    setup(props) {
        const { sizeClass, themeClass } = useBootstrapBadge(props);
        return { sizeClass, themeClass };
    },
    template: `
    <component :is="tag" class="badge" :class="[themeClass, sizeClass]">
      <slot />
    </component>
  `
});
